import { CREATE_QUESTIONS_START } from "../../types";

export const create_question = (payload) => ({
  type: CREATE_QUESTIONS_START,
  payload,
});
